import ReactGA from "react-ga4";

const measurementIdForDev = process.env.REACT_APP_MEASUREMENT_ID_FOR_DEV;
const measurementIdForProd = process.env.REACT_APP_MEASUREMENT_ID_FOR_PROD;
const sourceUrl = process.env.REACT_APP_SOURCE_URL;

export const initializeGA = () => {
  if (sourceUrl === "https://api.dev.modalx.ai/api") {
    ReactGA.initialize(measurementIdForDev); // Replace with your GA4 Measurement ID
  } else if (sourceUrl === "https://api.modalx.ai/api") {
    ReactGA.initialize(measurementIdForProd);
  }
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};



export const trackButtonEvent = (eventName, parameters) => {
  ReactGA.event(eventName, { ...parameters });
  // console.log(`Event Tracked: ${eventName}`, parameters);
};


export const trackFileUpload = (eventName, fileType, fileCount, uploadMethod) => {
  ReactGA.event(eventName, {
    file_count: fileCount,
    file_type: fileType,
    upload_method: uploadMethod,
  });

  // console.log(`Event Tracked: file_upload`, { file_type: fileType, file_count: fileCount, upload_method: uploadMethod });
};

export const trackLinkPaste = (linkUrl) => {
  ReactGA.event("link_paste", {
    link_url: linkUrl

  });
  // console.log('Event Tracked: link_paste', { link_url: linkUrl });
};

export const trackModalOpen = (modalName) => {
  ReactGA.event('modal_open', {
    modal_name: modalName,
  });
  // console.log(`Event Tracked: modal_open, Modal Name: ${modalName}`);
};

export const trackContentGeneration = (contentType, generationMethod) => {
  ReactGA.event('content_generation', {
    content_type: contentType,
    generation_method: generationMethod,
  });

  // console.log(`Event Tracked: content_generation, Content Type: ${contentType}, Generation Method: ${generationMethod}`);
};

export const trackSearchInteraction = (searchQuery) => {
  ReactGA.event('search_interaction', {
    search_query: searchQuery,
  });
  // console.log(`Event Tracked: search_interaction, Search Query: ${searchQuery}`);
};

export const trackNavigation = (fromPage, toPage) => {
  ReactGA.event("navigation", {
    navigation_from: fromPage,
    navigation_to: toPage
  });

  // console.log(`Navigation Event: ${fromPage} -> ${toPage}`);
};

export const trackProjectInteraction = (projectName, interactionType) => {
  ReactGA.event('project_interaction', {
    project_name: projectName,
    interaction_type: interactionType,
  });

  // console.log(`Project Interaction: ${projectName}, Type: ${interactionType}`);
};